<div class="card mb-4">
  <div class="card-body">
    <!-- create button  -->
    <button
      (click)="openAddDialog()"
      class="btn btn-outline-success btn-icon-split"
    >
      <span class="icon text-white-50">
        <i class="fas fa-plus"></i>
      </span>
      <span class="text">Thêm</span>
    </button>
    <!-- filter button  -->
    <button
      href="#"
      role="button"
      class="btn btn-outline-info btn-icon-split"
      (click)="showfilter = !showfilter"
    >
      <span class="icon text-white-50">
        <i class="fas fa-search"></i>
      </span>
      <span class="text">Lọc</span>
    </button>
    <!-- refresh button -->
    <button
      href="#"
      role="button"
      class="btn btn-outline-warning btn-icon-split"
      (click)="reloadPage()"
    >
      <span class="icon text-white-50">
        <i class="fas fa-redo"></i>
      </span>
      <span class="text">Làm mới</span>
    </button>

    <!-- show button -->
  <!--   <span style="margin: 3px" class="dropdown">
      <button
        class="btn btn-danger dropdown-toggle btn-icon-split"
        type="button"
        id="dropdownMenuButton"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
      >
        <span class="icon text-white-50">
          <i class="fas fa-eye"></i>
        </span>
        <span class="text">Hiện</span>
      </button>

      <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
        <a class="dropdown-item toggle-vis" href="" data-column="0">{{
          bookI18n?.isbnI18n
        }}</a>
        <a class="dropdown-item toggle-vis" href="" data-column="1">{{
          bookI18n?.titleI18n
        }}</a>
        <a class="dropdown-item toggle-vis" href="" data-column="2">{{
          bookI18n?.authorI18n
        }}</a>
        <a class="dropdown-item toggle-vis" href="" data-column="3">{{
          bookI18n?.categoryI18n
        }}</a>
        <a class="dropdown-item toggle-vis" href="" data-column="4">{{
          bookI18n?.publisherI18n
        }}</a>
        <a class="dropdown-item toggle-vis" href="" data-column="5">{{
          bookI18n?.StatusI18n
        }}</a>
      </div>
    </span> -->

<!--     <span style="margin: 3px" class="dropdown">
      <button
        class="btn btn-outline-secondary dropdown-toggle btn-icon-split"
        type="button"
        id="dropdownMenuButton"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
      >
        <span class="icon text-white-50">
          <i class="fas fa-filter"></i>
        </span>
        <span class="text">Filters</span>
      </button>

      <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
        <div class="navbar-collapse text-center" id="navbarResponsive">
          <ul class="navbar-nav ml-auto">
            <li class="nav-item dropdown">
              <a
                class="nav-link dropdown-toggle"
                href="#"
                id="navbarDropdownMenuLink"
                role="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                {{ bookI18n?.authorI18n }}
              </a>
              <div
                class="dropdown-menu"
                aria-labelledby="navbarDropdownMenuLink"
              >
                <a
                  class="dropdown-item"
                  (click)="filterByWriter(w)"
                  *ngFor="let w of writers"
                  href="#"
                  >{{ w.name }}</a
                >
              </div>
            </li>
            <li class="nav-item dropdown">
              <a
                class="nav-link dropdown-toggle"
                href="#"
                id="navbarDropdownMenuLink"
                role="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                {{ bookI18n?.edition_yearI18n }}
              </a>
              <div
                class="dropdown-menu"
                aria-labelledby="navbarDropdownMenuLink"
                *ngFor="let y of years"
              >
                <a class="dropdown-item" (click)="filterByYear(y)">{{ y }}</a>
              </div>
            </li>
            <li class="nav-item dropdown">
              <a
                class="nav-link dropdown-toggle"
                href="#"
                id="navbarDropdownMenuLink"
                role="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                {{ bookI18n?.categoryI18n }}
              </a>
              <div
                class="dropdown-menu"
                aria-labelledby="navbarDropdownMenuLink"
              >
                <a
                  class="dropdown-item"
                  *ngFor="let c of categories"
                  (click)="filterByCategory(c.id)"
                  >{{ c.category_name }}</a
                >
              </div>
            </li>
          </ul>
        </div>
      </div>
    </span> -->

    <span style="margin: 3px" class="dropdown">
      <button
        class="btn btn-outline-danger dropdown-toggle btn-icon-split"
        type="button"
        id="dropdownMenuButton"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
      >
        <span class="icon text-white-50">
          <i class="fas fa-bars"></i>
        </span>
        <span class="text">Nhóm theo</span>
      </button>

      <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
        <a class="dropdown-item toggle-vis" (click)="getBooks()" data-column="2"
          >Tất cả</a
        >
        <a
          class="dropdown-item toggle-vis"
          (click)="groupByAuthor()"
          data-column="2"
          >{{ bookI18n?.authorI18n }}</a
        >
        <a
          class="dropdown-item toggle-vis"
          (click)="groupByCategory()"
          data-column="3"
          >{{ bookI18n?.categoryI18n }}</a
        >
        <a
          class="dropdown-item toggle-vis"
          (click)="groupByPublisher()"
          data-column="4"
          >{{ bookI18n?.publisherI18n }}</a
        >
        <a
          class="dropdown-item toggle-vis"
          (click)="groupByEditionYear()"
          data-column="5"
          >{{ bookI18n?.edition_yearI18n }}</a
        >
      </div>
    </span>

    <br /><br />

    <div *ngIf="showfilter">
      <form [formGroup]="filterForm">
        <div class="form-group row">
          <label for="text1" class="col-3 col-form-label">{{
            bookI18n?.publishing_yearI18n
          }}</label>
          <div class="col-9">
            <input
              formControlName="publishing_year"
              id="text1"
              name="publishing_year"
              type="text"
              class="form-control"
            />
          </div>
        </div>
        <div class="form-group row">
          <label for="text" class="col-3 col-form-label">{{
            bookI18n?.number_of_pagesI18n
          }}</label>
          <div class="col-9">
            <input
              formControlName="number_of_pages"
              id="text"
              name="number_of_pages"
              type="text"
              class="form-control"
            />
          </div>
        </div>
        <div class="form-group row">
          <label for="text2" class="col-3 col-form-label">{{
            bookI18n?.publication_placeI18n
          }}</label>
          <div class="col-9">
            <input
              formControlName="publishing_place"
              id="text2"
              name="publishing_place"
              type="text"
              class="form-control"
            />
          </div>
        </div>

        <div class="form-group row">
          <label for="text2" class="col-3 col-form-label">{{
            bookI18n?.edition_yearI18n
          }}</label>
          <div class="col-9">
            <input
              formControlName="edition_year"
              id="text2"
              name="edition_year"
              type="text"
              class="form-control"
            />
          </div>
        </div>

        <div class="form-group row">
          <div class="offset-3 col-9">
            <button name="submit" (click)="add()" class="btn btn-primary">
              {{ bookI18n?.filterI18n }}
            </button>
          </div>
        </div>
      </form>
    </div>

    <!-- <div *ngIf="showsummary">
      <app-book-number></app-book-number>
    </div> -->

    <div class="container mt-5">

      <div class="row">
          <div class="col-md-4 mb-4">
              <div class="card text-center border">
                  <div class="card-body">
                      <h5 class="card-title text-dark">Tổng cộng</h5>
                      <p class="card-text h4">
                          <span *ngIf="totalCount">{{ totalCount }}</span>
                          <span *ngIf="!totalCount">Đang tải...</span>
                      </p>
                  </div>
              </div>
          </div>
    
          <div class="col-md-4 mb-4">
              <div class="card text-center border">
                  <div class="card-body">
                      <h5 class="card-title text-primary">Đã lưu trữ</h5>
                      <p class="card-text h4">
                          <span *ngIf="archived">{{ archived }}</span>
                          <span *ngIf="!archived">Đang tải...</span>
                      </p>
                  </div>
              </div>
          </div>
    
          <div class="col-md-4 mb-4">
              <div class="card text-center border">
                  <div class="card-body">
                      <h5 class="card-title text-danger">Đã hủy</h5>
                      <p class="card-text h4">
                          <span *ngIf="destroyed">{{ destroyed }}</span>
                          <span *ngIf="!destroyed">Đang tải...</span>
                      </p>
                  </div>
              </div>
          </div>
      </div>
    </div>
  </div>
</div>
